<template>
  <div class="container-tooltip">
    <table>
      <template v-if="mode === 'log'">
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.fileName') }}:</td>
          <td class="container-tooltip__content-name el-title">{{ title }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.filePath') }}:</td>
          <td class="container-tooltip__content-name el-path">{{ path }}</td>
        </tr>
      </template>
      <template v-else>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.tooltipName') }}:</td>
          <td class="container-tooltip__content-name">{{ name }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.description') }}:</td>
          <td class="container-tooltip__content-name">{{ description }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.targetTooltip') }}:</td>
          <td class="container-tooltip__content-name">{{ target }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.collectionUnit') }}:</td>
          <td class="container-tooltip__content-name">{{ unit }}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin';
import util from '@/utils/cmpLogin/util';

export default {
  name: 'TooltipPerformanceItem',
  mixins: [i18nMixin],
  props: {
    dataTooltip: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: ''
    }
  },
  computed: {
    getLocale() {
      return util.getLocale();
    },
    description() {
      if (this.getLocale === 'en' && this.dataTooltip.metric.metricDescriptionEn)
        return this.dataTooltip.metric.metricDescriptionEn.replace(/<br\s*\/?>/gi, '\n');

      if (this.getLocale === 'ko' && this.dataTooltip.metric.metricDescription)
        return this.dataTooltip.metric.metricDescription.replace(/<br\s*\/?>/gi, '\n');

      return '-';
    },
    target() {
      if (this.getLocale === 'en' && this.dataTooltip.metric.productTargetTypeEn)
        return this.dataTooltip.metric.productTargetTypeEn;

      if (this.getLocale === 'ko' && this.dataTooltip.metric.productTargetType)
        return this.dataTooltip.metric.productTargetType;

      return '-';
    },
    unit() {
      return this.dataTooltip.metric.metricUnit ? this.dataTooltip.metric.metricUnit : '-';
    },
    name() {
      return this.dataTooltip.metric.metricName || this.dataTooltip.metric.name || '-';
    },
    title() {
      if (this.mode === 'log') return this.dataTooltip.metric.logSq;
      return '';
    },
    path() {
      if (this.mode === 'log') return this.dataTooltip.metric.logPath;
      return '';
    }
  }
};
</script>

<style scoped lang="scss">
.container-tooltip__content-label {
  vertical-align: top;
  white-space: nowrap;
}
.container-tooltip__content-name {
  word-break: break-word;
  word-wrap: break-word;
}

.el-path {
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
}
.el-title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
}
</style>
